export const dimens = {
    small: 8,
    default: 16,
    medium: 32,
    large: 64,
    markdown_height: 250,
}